import React, { useState } from 'react';
import DigiportIssues from 'src/components/DigiportIssues';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';

const Digiport = (props) => {
  const [loading, setLoading] = useState(false);
  const [issues, setIssues] = useState([]);

  const fecthTickets = () => {
    setLoading(true);
    const user = getUser();
    // let jql = `reporter=${user.UserId}`;
    const jql = 'reporter=AR903213';
    axios.get(`/GetDigiportSearch/${jql}`)
      .then((response) => {

        setIssues(response.data !== '' && response.data.total && response.data.total > 0 ? response.data.issues : []);
        setLoading(false);
      }).catch((error) => {
        console.error(error);
        setIssues([]);
        setLoading(false);
      });
  };

  React.useEffect(() => {
    fecthTickets();
    // eslint-disable-next-line
  }, []);

  return (
    <DigiportIssues issues={issues} loading={loading} />
  );
};

export default Digiport;
